module.exports = __webpack_public_path__ + "static/media/utp-a6-foldover-notecard-bw.94e41450.png";